import { unionBy } from 'lodash';

// Action Types
export const UPLOAD_CSV_REQUEST = 'LEAD_ENRICHMENT_UPLOAD_CSV_REQUEST';
export const UPLOAD_CSV_SUCCESS = 'LEAD_ENRICHMENT_UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'LEAD_ENRICHMENT_UPLOAD_CSV_FAILURE';

export const GET_LEAD_LISTS_REQUEST = 'LEAD_ENRICHMENT_GET_LEAD_LISTS_REQUEST';
export const GET_LEAD_LISTS_SUCCESS = 'LEAD_ENRICHMENT_GET_LEAD_LISTS_SUCCESS';
export const GET_LEAD_LISTS_FAILURE = 'LEAD_ENRICHMENT_GET_LEAD_LISTS_FAILURE';

export const LOAD_MORE_LEAD_LISTS_REQUEST = 'LEAD_ENRICHMENT_LOAD_MORE_LEAD_LISTS_REQUEST';
export const LOAD_MORE_LEAD_LISTS_SUCCESS = 'LEAD_ENRICHMENT_LOAD_MORE_LEAD_LISTS_SUCCESS';
export const LOAD_MORE_LEAD_LISTS_FAILURE = 'LEAD_ENRICHMENT_LOAD_MORE_LEAD_LISTS_FAILURE';

export const GET_FILTERS_REQUEST = 'LEAD_ENRICHMENT_GET_FILTERS_REQUEST';
export const GET_FILTERS_SUCCESS = 'LEAD_ENRICHMENT_GET_FILTERS_SUCCESS';
export const GET_FILTERS_FAILURE = 'LEAD_ENRICHMENT_GET_FILTERS_FAILURE';

export const ADD_FILTER_REQUEST = 'LEAD_ENRICHMENT_ADD_FILTER_REQUEST';
export const ADD_FILTER_SUCCESS = 'LEAD_ENRICHMENT_ADD_FILTER_SUCCESS';
export const ADD_FILTER_FAILURE = 'LEAD_ENRICHMENT_ADD_FILTER_FAILURE';

export const TOGGLE_FILTER_REQUEST = 'LEAD_ENRICHMENT_TOGGLE_FILTER_REQUEST';
export const TOGGLE_FILTER_SUCCESS = 'LEAD_ENRICHMENT_TOGGLE_FILTER_SUCCESS';
export const TOGGLE_FILTER_FAILURE = 'LEAD_ENRICHMENT_TOGGLE_FILTER_FAILURE';

export const DELETE_FILTER_REQUEST = 'LEAD_ENRICHMENT_DELETE_FILTER_REQUEST';
export const DELETE_FILTER_SUCCESS = 'LEAD_ENRICHMENT_DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = 'LEAD_ENRICHMENT_DELETE_FILTER_FAILURE';

export const GET_FILTERED_LEADS_REQUEST = 'LEAD_ENRICHMENT_GET_FILTERED_LEADS_REQUEST';
export const GET_FILTERED_LEADS_SUCCESS = 'LEAD_ENRICHMENT_GET_FILTERED_LEADS_SUCCESS';
export const GET_FILTERED_LEADS_FAILURE = 'LEAD_ENRICHMENT_GET_FILTERED_LEADS_FAILURE';

export const GET_STATS_REQUEST = 'LEAD_ENRICHMENT_GET_STATS_REQUEST';
export const GET_STATS_SUCCESS = 'LEAD_ENRICHMENT_GET_STATS_SUCCESS';
export const GET_STATS_FAILURE = 'LEAD_ENRICHMENT_GET_STATS_FAILURE';

export const CLEAR_LEADS = 'LEAD_ENRICHMENT_CLEAR_LEADS';
export const CLEAR_FILTERS = 'LEAD_ENRICHMENT_CLEAR_FILTERS';

export const GET_LEAD_INFO_REQUEST = 'LEAD_ENRICHMENT_GET_LEAD_INFO_REQUEST';
export const GET_LEAD_INFO_SUCCESS = 'LEAD_ENRICHMENT_GET_LEAD_INFO_SUCCESS';
export const GET_LEAD_INFO_FAILURE = 'LEAD_ENRICHMENT_GET_LEAD_INFO_FAILURE';

export const DELETE_LEAD_LIST_REQUEST = 'LEAD_ENRICHMENT_DELETE_LEAD_LIST_REQUEST';
export const DELETE_LEAD_LIST_SUCCESS = 'LEAD_ENRICHMENT_DELETE_LEAD_LIST_SUCCESS';
export const DELETE_LEAD_LIST_FAILURE = 'LEAD_ENRICHMENT_DELETE_LEAD_LIST_FAILURE';

export const SYNC_LEAD_STATUS_REQUEST = 'LEAD_ENRICHMENT_SYNC_LEAD_STATUS_REQUEST';
export const SYNC_LEAD_STATUS_SUCCESS = 'LEAD_ENRICHMENT_SYNC_LEAD_STATUS_SUCCESS';
export const SYNC_LEAD_STATUS_FAILURE = 'LEAD_ENRICHMENT_SYNC_LEAD_STATUS_FAILURE';

export const EXPORT_UPLOADED_FILE_REQUEST = 'LEAD_ENRICHMENT_EXPORT_UPLOADED_FILE_REQUEST';
export const EXPORT_UPLOADED_FILE_SUCCESS = 'LEAD_ENRICHMENT_EXPORT_UPLOADED_FILE_SUCCESS';
export const EXPORT_UPLOADED_FILE_FAILURE = 'LEAD_ENRICHMENT_EXPORT_UPLOADED_FILE_FAILURE';

export const ADD_ENRICHMENT_COLUMN_REQUEST = 'LEAD_ENRICHMENT_ADD_ENRICHMENT_COLUMN_REQUEST';
export const ADD_ENRICHMENT_COLUMN_SUCCESS = 'LEAD_ENRICHMENT_ADD_ENRICHMENT_COLUMN_SUCCESS';
export const ADD_ENRICHMENT_COLUMN_FAILURE = 'LEAD_ENRICHMENT_ADD_ENRICHMENT_COLUMN_FAILURE';

export const UPDATE_LEAD_ENRICHMENT_INFO_SUCCESS = 'LEAD_ENRICHMENT_UPDATE_LEAD_ENRICHMENT_INFO_SUCCESS';

export const UPDATE_LEAD_ENRICHMENT_LIST_SUCCESS = 'LEAD_ENRICHMENT_UPDATE_LEAD_ENRICHMENT_LIST_SUCCESS';

export const STOP_ENRICHMENT_REQUEST = 'LEAD_ENRICHMENT_STOP_ENRICHMENT_REQUEST';
export const STOP_ENRICHMENT_SUCCESS = 'LEAD_ENRICHMENT_STOP_ENRICHMENT_SUCCESS';
export const STOP_ENRICHMENT_FAILURE = 'LEAD_ENRICHMENT_STOP_ENRICHMENT_FAILURE';

export const VALIDATE_COLUMNS_REQUEST = 'LEAD_ENRICHMENT_VALIDATE_COLUMNS_REQUEST';
export const VALIDATE_COLUMNS_SUCCESS = 'LEAD_ENRICHMENT_VALIDATE_COLUMNS_SUCCESS';
export const VALIDATE_COLUMNS_FAILURE = 'LEAD_ENRICHMENT_VALIDATE_COLUMNS_FAILURE';

export const CLEAR_VALIDATE_COLUMNS = 'LEAD_ENRICHMENT_CLEAR_VALIDATE_COLUMNS';
export const SET_AI_RESEARCH_MODAL_VISIBLE = 'LEAD_ENRICHMENT_SET_AI_RESEARCH_MODAL_VISIBLE';

export const UPDATE_LEAD_ENRICHMENT_FILTER_INFO_SUCCESS = 'LEAD_ENRICHMENT_UPDATE_LEAD_ENRICHMENT_FILTER_INFO_SUCCESS';
export const ADD_COLLAPSE_COLUMNS_REQUEST = 'LEAD_ENRICHMENT_ADD_COLLAPSE_COLUMNS_REQUEST';
export const ADD_COLLAPSE_COLUMNS_SUCCESS = 'LEAD_ENRICHMENT_ADD_COLLAPSE_COLUMNS_SUCCESS';
export const ADD_COLLAPSE_COLUMNS_FAILURE = 'LEAD_ENRICHMENT_ADD_COLLAPSE_COLUMNS_FAILURE';

export const TABLE_FILTERS_SUCCESS = 'LEAD_ENRICHMENT_TABLE_FILTERS_SUCCESS';
export const ADD_LINKEDIN_COLUMN_REQUEST = 'LEAD_ENRICHMENT_ADD_LINKEDIN_COLUMN_REQUEST';
export const ADD_LINKEDIN_COLUMN_SUCCESS = 'LEAD_ENRICHMENT_ADD_LINKEDIN_COLUMN_SUCCESS';
export const ADD_LINKEDIN_COLUMN_FAILURE = 'LEAD_ENRICHMENT_ADD_LINKEDIN_COLUMN_FAILURE';

export const ADD_EMAIL_COLUMN_REQUEST = 'LEAD_ENRICHMENT_ADD_EMAIL_COLUMN_REQUEST';
export const ADD_EMAIL_COLUMN_SUCCESS = 'LEAD_ENRICHMENT_ADD_EMAIL_COLUMN_SUCCESS';
export const ADD_EMAIL_COLUMN_FAILURE = 'LEAD_ENRICHMENT_ADD_EMAIL_COLUMN_FAILURE';

export const UPDATE_CONTACT_COLUMNS_REQUEST = 'LEAD_ENRICHMENT_UPDATE_CONTACT_COLUMNS_REQUEST';
export const UPDATE_CONTACT_COLUMNS_SUCCESS = 'LEAD_ENRICHMENT_UPDATE_CONTACT_COLUMNS_SUCCESS';
export const UPDATE_CONTACT_COLUMNS_FAILURE = 'LEAD_ENRICHMENT_UPDATE_CONTACT_COLUMNS_FAILURE';

export const STOP_FILTER_REQUEST = 'LEAD_ENRICHMENT_STOP_FILTER_REQUEST';
export const STOP_FILTER_SUCCESS = 'LEAD_ENRICHMENT_STOP_FILTER_SUCCESS';
export const STOP_FILTER_FAILURE = 'LEAD_ENRICHMENT_STOP_FILTER_FAILURE';

export const SAVE_FILTER_SUCCESS = 'LEAD_ENRICHMENT_SAVE_FILTER_SUCCESS';

export const START_PRE_SAVED_FILTER_REQUEST = 'LEAD_ENRICHMENT_START_PRE_SAVED_FILTER_REQUEST';
export const START_PRE_SAVED_FILTER_SUCCESS = 'LEAD_ENRICHMENT_START_PRE_SAVED_FILTER_SUCCESS';
export const START_PRE_SAVED_FILTER_FAILURE = 'LEAD_ENRICHMENT_START_PRE_SAVED_FILTER_FAILURE';

export const CLEAN_LEAD_ENRICHMENT_STATE = 'LEAD_ENRICHMENT_CLEAN_LEAD_ENRICHMENT_STATE';


export interface LeadEnrichmentFile {
  id: string;
  deleted_at: string | null;
  deleted_by_cascade: boolean;
  created_at: string;
  updated_at: string;
  list_name: string;
  source_name: string;
  attachment: string;
  file_type: string | null;
  file_name: string;
  created_by_user_id: number;
  process_started_at: string | null;
  process_completed_at: string | null;
  status: number;
  lead_analysis: any | null;
  lead_analysis_file_key: string | null;
  retry_count: number;
  notes: Record<string, any>;
  row_count: number;
  processed_rows: number;
  total_operations: number;
  created_by: any | null;
}

export interface Filter {
  id: string;
  deleted_at: string | null;
  deleted_by_cascade: boolean;
  created_at: string;
  updated_at: string;
  filter_name: string;
  filter_query: string;
  filtered_rows: Record<string, any>;
  filtered_count: number;
  matched_count: number;
  status: number;
  is_active: boolean;
  is_stopped: boolean;
  process_started_at: string | null;
  process_completed_at: string | null;
  created_by_user_id: number;
  created_by: any | null;
  lead_enrichment: string;
  suggested_column_names?: string[];
}

export interface LeadEnrichmentState {
  uploadingCSV: boolean;
  leadLists: LeadEnrichmentFile[];
  leadListsMetaData: {
    count: number;
    page_size: number;
    page_count: number;
    has_next: boolean;
  };
  leadListsLoading: boolean;
  filters: any[];
  filtersMetaData: {
    count: number;
    page_size: number;
    page_count: number;
    has_next: boolean;
  };
  filtersLoading: boolean;
  addFilterLoading: boolean;
  toggleFilterLoading: boolean;
  deleteFilterLoading: boolean;
  filteredLeads: any[];
  filteredLeadsMetaData: {
    count: number;
    page_size: number;
    page_count: number;
    has_next: boolean;
  };
  filteredLeadsLoading: boolean;
  stats: any;
  statsLoading: boolean;
  leadInfo: any;
  leadInfoLoading: boolean;
  isAIResearchModalVisible: boolean;
  addEnrichmentColumnLoading: boolean;
  validateColumnsLoading: boolean;
  validationResults: { filterable: boolean, reason: string, suggested_columns: { column_name: string, description: string }[] } | null;
  addCollapseColumnsLoading: boolean;
  addLinkedInColumnLoading: boolean;
  addEmailColumnLoading: boolean;
  updateContactColumnsLoading: boolean;
  startPreSavedFilterLoading: Map<string, boolean> | null;
  exportUploadedFileLoading: boolean;
}

const initialState: LeadEnrichmentState = {
  uploadingCSV: false,
  leadLists: [],
  leadListsMetaData: {
    count: 0,
    page_size: 0,
    page_count: 0,
    has_next: false,
  },
  leadListsLoading: false,
  filters: [],
  filtersMetaData: {
    count: 0,
    page_size: 0,
    page_count: 0,
    has_next: false,
  },
  filtersLoading: false,
  addFilterLoading: false,
  toggleFilterLoading: false,
  deleteFilterLoading: false,
  filteredLeads: [],
  filteredLeadsMetaData: {
    count: 0,
    page_size: 0,
    page_count: 0,
    has_next: false,
  },
  filteredLeadsLoading: false,
  stats: {},
  statsLoading: false,
  leadInfo: {},
  leadInfoLoading: false,
  isAIResearchModalVisible: false,
  addEnrichmentColumnLoading: false,
  validateColumnsLoading: false,
  validationResults: null,
  addCollapseColumnsLoading: false,
  addLinkedInColumnLoading: false,
  addEmailColumnLoading: false,
  updateContactColumnsLoading: false,
  startPreSavedFilterLoading: null,
  exportUploadedFileLoading: false,
}

export const leadEnrichmentReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case UPLOAD_CSV_REQUEST:
      return { ...state, uploadingCSV: true };
    case UPLOAD_CSV_SUCCESS:
      return { ...state, uploadingCSV: false };
    case UPLOAD_CSV_FAILURE:
      return { ...state, uploadingCSV: false };
    case GET_LEAD_LISTS_REQUEST:
      return { ...state, leadListsLoading: true };
    case GET_LEAD_LISTS_SUCCESS:
      return { ...state, leadLists: action.response.data, leadListsMetaData: action.response.meta || action.response.metadata, leadListsLoading: false };
    case GET_LEAD_LISTS_FAILURE:
      return { ...state, leadListsLoading: false };
    case LOAD_MORE_LEAD_LISTS_REQUEST:
      return { ...state, leadListsLoading: true };
    case LOAD_MORE_LEAD_LISTS_SUCCESS:
      return { ...state, leadLists: unionBy([...state.leadLists, ...action.response.data], 'id'), leadListsMetaData: action.response.meta || action.response.metadata, leadListsLoading: false };
    case LOAD_MORE_LEAD_LISTS_FAILURE:
      return { ...state, leadListsLoading: false };
    case GET_FILTERS_REQUEST:
      return { ...state, filtersLoading: true };
    case GET_FILTERS_SUCCESS:
      return { ...state, filters: action.response.data, filtersMetaData: action.response.meta || action.response.metadata, filtersLoading: false };
    case GET_FILTERS_FAILURE:
      return { ...state, filtersLoading: false };
    case ADD_FILTER_REQUEST:
      return { ...state, addFilterLoading: true };
    case ADD_FILTER_SUCCESS:
      return { ...state, filters: [action.response.filter, ...state.filters], leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data }, addFilterLoading: false };
    case ADD_FILTER_FAILURE:
      return { ...state, addFilterLoading: false };
    case SAVE_FILTER_SUCCESS:
      return { ...state, filters: [action.response.filter, ...state.filters] };
    case TOGGLE_FILTER_REQUEST:
      return { ...state, toggleFilterLoading: true };
    case TOGGLE_FILTER_SUCCESS:
      return { ...state, filters: action.response.filters, leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data }, toggleFilterLoading: false };
    case TOGGLE_FILTER_FAILURE:
      return { ...state, toggleFilterLoading: false };
    case DELETE_FILTER_REQUEST:
      return { ...state, deleteFilterLoading: true };
    case DELETE_FILTER_SUCCESS:
      return { ...state, filters: action.response.filters, leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data, decoded_data_copy: action.response.decoded_data_copy }, deleteFilterLoading: false };
    case DELETE_FILTER_FAILURE:
      return { ...state, deleteFilterLoading: false };
    case GET_FILTERED_LEADS_REQUEST:
      return { ...state, filteredLeadsLoading: true };
    case GET_FILTERED_LEADS_SUCCESS:
      return { ...state, filteredLeads: action.response.data, filteredLeadsMetaData: action.response.meta || action.response.metadata || {}, filteredLeadsLoading: false };
    case GET_FILTERED_LEADS_FAILURE:
      return { ...state, filteredLeadsLoading: false };
    case GET_STATS_REQUEST:
      return { ...state, statsLoading: true };
    case GET_STATS_SUCCESS:
      return { ...state, stats: action.response, statsLoading: false };
    case GET_STATS_FAILURE:
      return { ...state, statsLoading: false };
    case CLEAR_LEADS:
      return { ...state, leadLists: [] };
    case CLEAR_FILTERS:
      return { ...state, filters: [], filtersMetaData: {} };
    case GET_LEAD_INFO_REQUEST:
      return { ...state, leadInfoLoading: true };
    case GET_LEAD_INFO_SUCCESS:
      return { ...state, leadInfo: action.response, leadInfoLoading: false, filters: action.filters };
    case GET_LEAD_INFO_FAILURE:
      return { ...state, leadInfoLoading: false };
    case DELETE_LEAD_LIST_REQUEST:
      return { ...state };
    case DELETE_LEAD_LIST_SUCCESS:
      return { ...state, leadLists: state.leadLists.filter(list => list.id !== action.id) };
    case DELETE_LEAD_LIST_FAILURE:
      return { ...state };
    case SYNC_LEAD_STATUS_REQUEST:
      return { ...state };
    case SYNC_LEAD_STATUS_SUCCESS:
      return { ...state, leadLists: action.response.data || state.leadLists };
    case SYNC_LEAD_STATUS_FAILURE:
      return { ...state };
    case EXPORT_UPLOADED_FILE_REQUEST:
      return { ...state, exportUploadedFileLoading: true };
    case EXPORT_UPLOADED_FILE_SUCCESS:
      return { ...state, exportUploadedFileLoading: false };
    case EXPORT_UPLOADED_FILE_FAILURE:
      return { ...state, exportUploadedFileLoading: false };
    case ADD_ENRICHMENT_COLUMN_REQUEST:
      return { ...state, addEnrichmentColumnLoading: true };
    case ADD_ENRICHMENT_COLUMN_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response }, addEnrichmentColumnLoading: false, validationResults: null };
    case ADD_ENRICHMENT_COLUMN_FAILURE:
      return { ...state, addEnrichmentColumnLoading: false };
    case UPDATE_LEAD_ENRICHMENT_INFO_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response } };
    case UPDATE_LEAD_ENRICHMENT_LIST_SUCCESS:
      return { ...state, leadLists: action.response };
    case STOP_ENRICHMENT_REQUEST:
      return { ...state };
    case STOP_ENRICHMENT_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response } };
    case STOP_ENRICHMENT_FAILURE:
      return { ...state };
    case VALIDATE_COLUMNS_SUCCESS:
      return { ...state, validationResults: action.response, validateColumnsLoading: false };
    case VALIDATE_COLUMNS_FAILURE:
      return { ...state, validationResults: null, validateColumnsLoading: false };
    case VALIDATE_COLUMNS_REQUEST:
      return { ...state, validateColumnsLoading: true, validationResults: null };
    case CLEAR_VALIDATE_COLUMNS:
      return { ...state, validationResults: null };
    case SET_AI_RESEARCH_MODAL_VISIBLE:
      return { ...state, isAIResearchModalVisible: action.visible };
    case UPDATE_LEAD_ENRICHMENT_FILTER_INFO_SUCCESS:
      return { ...state, filters: action.response.filters, leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data, decoded_data_copy: action.response.decoded_data_copy } };
    case TABLE_FILTERS_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data } };
    case ADD_COLLAPSE_COLUMNS_REQUEST:
      return { ...state, addCollapseColumnsLoading: true };
    case ADD_COLLAPSE_COLUMNS_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response }, addCollapseColumnsLoading: false };
    case ADD_COLLAPSE_COLUMNS_FAILURE:
      return { ...state, addCollapseColumnsLoading: false };
    case ADD_LINKEDIN_COLUMN_REQUEST:
      return { ...state, addLinkedInColumnLoading: true };
    case ADD_LINKEDIN_COLUMN_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response }, addLinkedInColumnLoading: false };
    case ADD_LINKEDIN_COLUMN_FAILURE:
      return { ...state, addLinkedInColumnLoading: false };
    case UPDATE_CONTACT_COLUMNS_REQUEST:
      return { ...state, updateContactColumnsLoading: true };
    case UPDATE_CONTACT_COLUMNS_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, linkedin_url_column_name: action.response.linkedin_url_column_name, email_column_name: action.response.email_column_name }, leadLists: action.response.leadLists, updateContactColumnsLoading: false };
    case UPDATE_CONTACT_COLUMNS_FAILURE:
      return { ...state, updateContactColumnsLoading: false };
    case ADD_EMAIL_COLUMN_REQUEST:
      return { ...state, addEmailColumnLoading: true };
    case ADD_EMAIL_COLUMN_SUCCESS:
      return { ...state, leadInfo: { ...state.leadInfo, ...action.response }, addEmailColumnLoading: false };
    case ADD_EMAIL_COLUMN_FAILURE:
      return { ...state, addEmailColumnLoading: false };
    case STOP_FILTER_REQUEST:
      return { ...state };
    case STOP_FILTER_SUCCESS:
      return { ...state, filters: action.response.filters };
    case STOP_FILTER_FAILURE:
      return { ...state, filters: action.response.filters };
    case START_PRE_SAVED_FILTER_REQUEST:
      return { ...state, startPreSavedFilterLoading: new Map(state.startPreSavedFilterLoading).set(action.id, true) };
    case START_PRE_SAVED_FILTER_SUCCESS:
      return { ...state, filters: action.response.filters, leadInfo: { ...state.leadInfo, decoded_data: action.response.decoded_data, decoded_data_copy: action.response.decoded_data_copy }, startPreSavedFilterLoading: new Map(state.startPreSavedFilterLoading).set(action.id, false) };
    case START_PRE_SAVED_FILTER_FAILURE:
      return { ...state, startPreSavedFilterLoading: new Map(state.startPreSavedFilterLoading).set(action.id, false) };
    case CLEAN_LEAD_ENRICHMENT_STATE:
      return { ...initialState };
    default:
      return state;
  }
};
